/**
 * @file Contributor assignment related fragments.
 */

import gql from 'graphql-tag';

export const ContributorAssignmentShareBaseDetails = gql`
  fragment ContributorAssignmentShareBaseDetails on ContributorAssignmentShare {
    id
    upload_access
    view_access
    album_create_access
    email_address
    phone_number
    album_folder {
      id
      name
      is_root
      contributor_assignment_shares(
        include_inherited: true
        pending_only: true
        include_nested: true
        without_account_uuid: false
      ) {
        total
      }
    }
    album {
      id
      name
    }
    first_name
    last_name
    account_profile {
      id
      name
      username
      avatar_photo {
        id
        thumbnail_urls {
          url
          size_code
          width
          height
        }
      }
      friend_status {
        is_friend
      }
    }
  }
`;

export const ContributorAssignmentBaseDetails = gql`
  fragment ContributorAssignmentBaseDetails on ContributorAssignment {
    id
    upload_access
    view_access
    album_create_access
    account {
      id
      email_address
      phone_number
    }
    album_folder {
      id
      name
      is_root
    }
    album {
      id
      name
    }
    account_display_name
    contributor_assignment_share {
      id
      ...ContributorAssignmentShareBaseDetails
    }
  }
  ${ContributorAssignmentShareBaseDetails}
`;

export const AutoContributorSettingsDetails = gql`
  fragment AutoContributorSettingsDetails on AutoContributorSettings {
    upload_access
    dnp_access
    view_access
    album_create_access
  }
`;
